import { inject } from '@angular/core';
import { DialogService } from '@core/services';
import { BaseComponent } from '@shared/classes';
import { UnselectChallengeModalComponent } from '@shared/components/modals/unselect-challenge-modal/unselect-challenge-modal.component';
import { CampaignPhase } from '@shared/constants';
import { AnyChallenge, EmitterKeys } from '@shared/models';

export class UnselectionButtonBaseClass extends BaseComponent {
  private readonly dialog: DialogService = inject(DialogService);

  displayUnselectDialog(
    phase: CampaignPhase,
    challenge: AnyChallenge,
    isBisCampaign: boolean,
    isEventChallenge: boolean
  ): void {
    this.taggingService.emitTagForKey(EmitterKeys.UNSELECT_CHALLENGE);

    this.dialog.open(UnselectChallengeModalComponent, {
      data: {
        phase: phase,
        challenge: challenge,
        isBisCampaign: isBisCampaign,
        isEventChallenge: isEventChallenge,
      },
    });
  }
}
